import { useAnalytics } from 'edrolo/analytics';
import PT from 'prop-types';
import Select from 'react-select-4';
import {
  ENABLED_WORKING_PATHWAYS_FILTER_COURSE_IDS,
  SPICINESS_LEVEL,
  WORKING_PATHWAYS,
} from '../../../../../../constants';
import { setSearchParams } from '../../../../../../utils';
import { Label } from './Label';
import s from './styles.scss';

export const Filter = ({
  searchParams,
  filterToggle,
  courseId,
  analyticsPayload,
}) => {
  const { track } = useAnalytics({});

  const flagIsActive = global.waffle.flag_is_active(
    'enable_working_pathway_filter'
  );
  const courseEnabled =
    ENABLED_WORKING_PATHWAYS_FILTER_COURSE_IDS.includes(courseId);
  const noItems = !filterToggle.hasSpiciness && !filterToggle.hasWorkingPaths;
  const show = flagIsActive || courseEnabled;

  if (!show || noItems) {
    return null;
  }

  function handleChange(selectedOptions, param) {
    const values = [...selectedOptions].map((option) => option.value);

    setSearchParams(searchParams, param, values);

    const readableValues = values.map((value) =>
      param === 'working_paths'
        ? WORKING_PATHWAYS[value]
        : SPICINESS_LEVEL[value]
    );

    const trackingData = {
      ...analyticsPayload,
      course_id: courseId,
      origin: 'Question set filter',
      [param]: readableValues,
    };

    const trackingTitle =
      readableValues.length === 0
        ? 'Question set filter removed'
        : 'Question set filter applied';

    track(trackingTitle, trackingData);
  }

  const options = {
    spiciness: [
      {
        value: 1,
        label: <Label.Mild />,
      },
      {
        value: 2,
        label: <Label.Medium />,
      },
      {
        value: 3,
        label: <Label.Spicy />,
      },
    ],
    workingPaths: [
      {
        value: 1,
        label: <Label.MildPath />,
      },
      {
        value: 2,
        label: <Label.MediumPath />,
      },
      {
        value: 3,
        label: <Label.SpicyPath />,
      },
    ],
  };

  const defaultWorkingPaths = searchParams
    .get('working_paths')
    ?.split(',')
    .map((value) => options.workingPaths[parseInt(value) - 1]);
  const defaultSpiciness = searchParams
    .get('spiciness')
    ?.split(',')
    .map((value) => options.spiciness[parseInt(value) - 1]);

  return (
    <div className={s.filter}>
      {filterToggle.hasSpiciness && (
        <div>
          <Select
            isMulti
            placeholder="Select spiciness"
            options={options.spiciness}
            defaultValue={defaultSpiciness}
            onChange={(options) => handleChange(options, 'spiciness')}
          />
        </div>
      )}

      {filterToggle.hasWorkingPaths && (
        <div>
          <Select
            isMulti
            placeholder="Select working path"
            options={options.workingPaths}
            defaultValue={defaultWorkingPaths}
            onChange={(options) => handleChange(options, 'working_paths')}
          />
        </div>
      )}
    </div>
  );
};

Filter.propTypes = {
  searchParams: PT.object.isRequired,
  filterToggle: PT.shape({
    hasSpiciness: PT.bool.isRequired,
    hasWorkingPaths: PT.bool.isRequired,
  }).isRequired,
  courseId: PT.number.isRequired,
  analyticsPayload: PT.object.isRequired,
};
